import {
  ACCESS_TOKEN_NAME,
  FORM_DATA_CONTENT_TYPE,
} from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { IFileUpload } from '../interface/IFileUpload';
import { getCookie, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const apiUploadFile = async (
  type: number,
  section: string,
  route: string,
  page: string,
  fileUpload: IFileUpload,
  onUploadProgress?: (e: any) => void,
  cancelToken?: any
) => {
  const params: IApiParams = {
    url: `/admin/addFile.php?section=${section}&route=${route}&page=${page}&type=${type}&${secureToken()}`,
    headers: {
      'Content-Type': FORM_DATA_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', fileUpload.data, onUploadProgress, cancelToken);
};
